import React, { useContext, useEffect } from 'react';

import strings from 'common/strings';
import permissions from 'common/permissions';
import { VehicleCardTabType } from 'models';

import VehicleCardReconDetails from './VehicleCardReconDetails';
import VehicleCardInventoryDetails from './VehicleCardInventoryDetails';
import VehicleCardEngageDetails from './VehicleCardEngageDetails';
import { VehicleCardContext } from '../../VehicleCard';
import { usePermissions } from 'hooks';

import './VehicleCardReconInventoryTabs.scss';
import VehicleCardNotes from '../VehicleCardNotes';
interface VehicleCardReconInventoryTabsProps {
  showNotesTab?: boolean;
}
var VehicleCardReconInventoryTabs = ({
  showNotesTab = false,
}: VehicleCardReconInventoryTabsProps) => {
  const {
    inExtensionCardMode,
    position,
    forceShowEngageTab,
    setCurrentTab,
    currentTab,
    vehicle,
  } = useContext(VehicleCardContext);
  const onClick = (activeCollectionType: VehicleCardTabType) => {
    if (setCurrentTab !== undefined) {
      setCurrentTab(activeCollectionType);
    }
  };

  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (!showNotesTab && currentTab === 'notes') {
      const tab =
        (hasPermission(permissions.RECON_VIEW) && 'recon') ||
        (hasPermission(permissions.INVENTORY_VIEW) && 'inventory') ||
        (hasPermission(permissions.PLUGIN_VELOCITYENGAGE_VIEW) && 'engage');

      setCurrentTab?.(tab);
    }
  }, [currentTab, hasPermission, setCurrentTab, showNotesTab]);

  return (
    <div className="VehicleCard-recon-inventory-tabs">
      <div
        className="VehicleCard-recon-inventory-tabs-container"
        data-vas-testing={`VehicleCard-tabs-container-${position.toString()}`}
      >
        {hasPermission(permissions.RECON_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3  ${
              currentTab === 'recon' ? 'active' : ''
            }`}
            onClick={() => onClick('recon')}
          >
            {strings.RECON}
          </div>
        )}
        {hasPermission(permissions.INVENTORY_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'inventory' ? 'active' : ''
            }`}
            onClick={() => onClick('inventory')}
          >
            {strings.INVENTORY}
          </div>
        )}
        {hasPermission(permissions.PLUGIN_VELOCITYENGAGE_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'engage' ? 'active' : ''
            }`}
            onClick={() => onClick('engage')}
          >
            {strings.ENGAGE}
          </div>
        )}
        {showNotesTab && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'notes' ? 'active' : ''
            }`}
            onClick={() => onClick('notes')}
          >
            {strings.NOTES}
          </div>
        )}
      </div>
      <div className="VehicleCard-recon-inventory-tab-content">
        {currentTab === 'recon' && <VehicleCardReconDetails />}
        {currentTab === 'inventory' && <VehicleCardInventoryDetails />}
        {currentTab === 'engage' &&
          (forceShowEngageTab || inExtensionCardMode) && (
            <VehicleCardEngageDetails />
          )}
        {currentTab === 'notes' && (
          <VehicleCardNotes
            vehicleId={vehicle?.vehicleCard?.id!}
            notes={vehicle?.notes!}
            showHeader={false}
          />
        )}
      </div>
    </div>
  );
};

export default VehicleCardReconInventoryTabs;
